import { Link } from "react-router-dom";
import site from "../data/site";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Industries", to: "/industries" },
  { label: "Contact", to: "/contact" },
];

const legal = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Service", to: "/terms-of-service" },
  { label: "Data Deletion", to: "/data-deletion" },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__about">
            <Link className="brand brand--footer" to="/" aria-label={`${site.brand} home`}>
              <span className="brand__glyph">o</span>
              <span className="odinno-font brand__text">dinno</span>
            </Link>
            <p className="footer__about-text">
              Odinno is a leading software house and Meta technology integration
              partner — delivering WhatsApp Business API, Meta Ads automation and
              custom software solutions that help businesses grow smarter.
            </p>
          </div>

          <div className="footer__col">
            <h6 className="footer__heading">Quick Links</h6>
            <ul className="footer__list">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h6 className="footer__heading">Legal</h6>
            <ul className="footer__list">
              {legal.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h6 className="footer__heading">Contact</h6>
            <p className="footer__contact">
              <i className="bi bi-geo-alt-fill footer__icon" />
              {site.location} <span aria-label="Pakistan">🇵🇰</span>
            </p>
            <p className="footer__contact">
              <i className="bi bi-envelope-fill footer__icon" />
              <a href={`mailto:${site.email}`}>{site.email}</a>
            </p>
            <p className="footer__contact">
              <i className="bi bi-whatsapp footer__icon" />
              <a
                href={site.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp: {site.phone}
              </a>
            </p>
            <div className="footer__socials">
              {site.socials.map((social) => (
                <a
                  key={social.name}
                  className="social-btn"
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  <i className={`bi bi-${social.name}`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <hr className="footer__divider" />
        <p className="footer__copyright">
          © {site.copyrightYear} <span className="gradient-text">{site.brand}</span>. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
